<template>
  <div class="page-wrapper" id="app">
    <div class="page-inner bg-brand-gradient">
        <div class="page-content-wrapper bg-transparent m-0">
            <div class="height-10 w-100 shadow-lg px-4 bg-brand-gradient">
                <div class="d-flex align-items-center container p-0">
                    <div class="page-logo width-mobile-auto m-0 align-items-center justify-content-center p-0 bg-transparent bg-img-none shadow-0 height-9">
                        <router-link class="page-logo-link press-scale-down d-flex align-items-center" :to="{name: 'index'}">
                            <img src="/img/logo.png" alt="SmartAdmin WebApp" aria-roledescription="logo">
                            <span class="page-logo-text mr-1">UPTIME.CENTER</span>
                        </router-link>
                    </div>
                    <div class="ml-auto">
                      <router-link class="btn-link text-white ml-5" :to="{name: 'account/login'}" v-if="!$route.path.startsWith('/account/login')">
                        Авторизация
                      </router-link>
                      <router-link class="btn-link text-white ml-5" :to="{name: 'account/registration'}" v-if="!$route.path.startsWith('/account/registration')">
                        Регистрация
                      </router-link>
                    </div>
                </div>
            </div>
            <div class="flex-1" style="background: url(/img/svg/pattern-1.svg) no-repeat center bottom fixed; background-size: cover;">
                <div class="container py-4 py-lg-5 my-lg-5 px-4 px-sm-0">
                    <router-view class="row"/>
                    <div class="position-absolute pos-bottom pos-left pos-right p-3 text-center text-white">
                        {{ new Date().getFullYear() }} © UPTIME.CENTER
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
  export default {
    metaInfo: {
      title: 'Центр мониторинга',
      link: [
        { rel: 'stylesheet', href: '/css/vendors.bundle.css' },
        { rel: 'stylesheet', href: '/css/app.bundle.css' },
        { rel: 'stylesheet', href: '/css/fa-brands.css' },
      ],
    }
  }
</script>